/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkTimeAllocationResponse
 */
export interface WorkTimeAllocationResponse {
    /**
     * 
     * @type {string}
     * @memberof WorkTimeAllocationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkTimeAllocationResponse
     */
    workArea: string;
    /**
     * 
     * @type {number}
     * @memberof WorkTimeAllocationResponse
     */
    hours: number;
    /**
     * 
     * @type {string}
     * @memberof WorkTimeAllocationResponse
     */
    team: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkTimeAllocationResponse
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkTimeAllocationResponse
     */
    validTo: Date | null;
}

/**
 * Check if a given object implements the WorkTimeAllocationResponse interface.
 */
export function instanceOfWorkTimeAllocationResponse(value: object): value is WorkTimeAllocationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('workArea' in value) || value['workArea'] === undefined) return false;
    if (!('hours' in value) || value['hours'] === undefined) return false;
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    return true;
}

export function WorkTimeAllocationResponseFromJSON(json: any): WorkTimeAllocationResponse {
    return WorkTimeAllocationResponseFromJSONTyped(json, false);
}

export function WorkTimeAllocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkTimeAllocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'workArea': json['workArea'],
        'hours': json['hours'],
        'team': json['team'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': (json['validTo'] == null ? null : new Date(json['validTo'])),
    };
}

export function WorkTimeAllocationResponseToJSON(json: any): WorkTimeAllocationResponse {
    return WorkTimeAllocationResponseToJSONTyped(json, false);
}

export function WorkTimeAllocationResponseToJSONTyped(value?: WorkTimeAllocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'workArea': value['workArea'],
        'hours': value['hours'],
        'team': value['team'],
        'validFrom': `${value['validFrom'].getFullYear()}-${String(value['validFrom'].getMonth()+1).padStart(2,'0')}-${String(value['validFrom'].getDate()).padStart(2,'0')}`,
        'validTo': value['validTo'] == null ? value['validTo'] : `${value['validTo'].getFullYear()}-${String(value['validTo'].getMonth()+1).padStart(2,'0')}-${String(value['validTo'].getDate()).padStart(2,'0')}`,
    };
}

